import { render } from "./FranchiseComponent.vue?vue&type=template&id=36acc372&scoped=true"
import script from "./FranchiseComponent.vue?vue&type=script&lang=js"
export * from "./FranchiseComponent.vue?vue&type=script&lang=js"

import "./FranchiseComponent.vue?vue&type=style&index=0&id=36acc372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36acc372"]])

export default __exports__